import { useState } from "react";

export default function FaqSection({ title, items }) {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="container mx-auto max-w-3xl">
      <h2 className="text-2xl sm:text-3xl font-bold text-center mb-10 text-gray-900">
        {title}
      </h2>
      <div className="space-y-3">
        {items.map((item, index) => (
          <div
            key={item.question}
            className="border border-gray-200 rounded-xl overflow-hidden bg-white"
          >
            <button
              type="button"
              onClick={() => toggle(index)}
              className="w-full text-left px-5 py-4 font-semibold text-gray-900 flex justify-between items-center hover:bg-gray-50 transition"
              aria-expanded={activeIndex === index}
            >
              <span>{item.question}</span>
              <span className="text-brand-primary text-xl ml-4 flex-shrink-0">
                {activeIndex === index ? "−" : "+"}
              </span>
            </button>
            {activeIndex === index && (
              <div className="px-5 pb-4 text-gray-600 text-sm leading-relaxed">
                {item.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
